import React, { useState, useContext } from 'react';
import Wichtigeangaben from './Wichtigeangaben';
import Form from 'react-bootstrap/Form';
import Baujahr from '../../components/Baujahr';
import { DataContext } from './../../App';

export default function Objektangaben(params) {
  let [page, setPage] = useState(0);
  const {
    flache,
    setFlache,
    grundstuck,
    setGrundstuck,
    anzahlDerEinheiten,
    setAnzahlDerEinheiten,
  } = useContext(DataContext);

  let previousPage = () => {
    setPage(0);
  };

  return (
    <>
      {page === 0 && (
        <>
          <h2>
            <strong>OBJEKTANGABEN</strong>
            <hr />
          </h2>

          <div className='choices-list-four flex-container'>
            <div className='choice'>
              <Baujahr />
              <p>BAUJAHR</p>
            </div>
            <div className='choice'>
              <Form.Control
                value={anzahlDerEinheiten}
                onChange={(e) => setAnzahlDerEinheiten(e.target.value)}
                type='number'
                placeholder='z. B. 2'
              />
              <p>ANZAHL DER EINHEITEN</p>
            </div>
            <div className='choice'>
              <Form.Control
                value={flache}
                onChange={(e) => setFlache(e.target.value)}
                type='number'
                placeholder='m²'
              />
              <p>WOHNFLÄCHE</p>
            </div>
            <div className='choice'>
              <Form.Control
                value={grundstuck}
                onChange={(e) => setGrundstuck(e.target.value)}
                type='number'
                placeholder='m²'
              />
              <p>GRUNDSTÜCK</p>
            </div>
          </div>
          <div className='buttons'>
            <button className='previous' onClick={params.previousPage}>
              Zurück
            </button>
            <button className='next' onClick={() => setPage(1)}>
              Weiter
            </button>
          </div>
        </>
      )}
      {page === 1 && <Wichtigeangaben previousPage={previousPage} />}
    </>
  );
}
